<template>
    <div class="group">
        <div class="name">{{ translate(optionGroup.name) }}</div>
        <div class="entries">
            <CartItemOption
                v-for="option in optionGroup.items"
                :key="option.id"
                :option="option"
                :multiplier="multiplier"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ICartItemOptionGroup } from "@/data/model/Customer";
    import { translate } from "@/shared/localization/language";

    import CartItemOption from "@/app/components/cart/CartItemOption.vue";

    // define properties
    defineProps<{
        optionGroup: ICartItemOptionGroup;
        multiplier: number;
    }>();
</script>

<style lang="scss"></style>
